<div class="dont-print ibm-plex-page">
  <div class="slab-lang">
    <div>
      <button
        *ngIf="langService.isUsingLiveTranslations()"
        class="button is-small is-danger"
        (click)="langService.deactivateLiveTranslations()"
      >LIVE UPDATE</button>
      <a href="/#/mpt-launch">
        <img class="logo" [src]="displayLogo()" alt="eqao_logo" />
      </a>
    </div>
    <div class="in-row" [class.in-column]="userInfo">
      <div class="profile-formlet">
        <div *ngIf="!userInfo">
          <button class="new-btn is-black login is-small" [routerLink]="getLoginRoute()" >
            <span class="login-icon"><i class="far fa-user"></i></span>
            <span class="login-title"><tra slug="title_login"></tra></span>
          </button>
        </div>
        <div *ngIf="userInfo" class="logged-user">
          <div style="margin-right: 0.5em;">
            <div [ngSwitch]="!!accountInfo" class="user-display-name">
              <span *ngIf="newMessage" (click)="onClickNewMessage()">
                <a [routerLink]="'/en/chat/' + messagePoolId"> <i class="fa fa-envelope" aria-hidden="true"></i> </a>|
              </span>
              <span *ngSwitchCase="true"> <a [routerLink]="accountInfo">{{getUserDisplayName()}}</a>  </span>
              <span *ngSwitchCase="false">{{getUserDisplayName()}}</span>
            </div>
            <div style="opacity:0.8; font-size:0.7em;">
              <div><b><tra slug="title_timezone"></tra> </b>{{timeZone}}</div>
            </div>
          </div>
          <div>
            <button class="new-btn is-outlined login is-danger logout" style="margin-right:0em ;" (click)="logout()">
                <span class="login-icon"><i class="fas fa-sign-out-alt"></i></span>
                <span class="login-title"><tra slug="title_logout"></tra></span>
            </button>
          </div>
        </div>
      </div>
      <div class="in-row"  [class.logged-user]="userInfo">
        <span *ngFor="let lang of langs; let i = index">
          <button
              (click)="setLang(lang.code)"
              class="new-btn is-small"
              [class.is-french]="i == 1"
              [class.is-white]="!isLangActive(lang.code)"
              [class.is-black]="isLangActive(lang.code)">{{lang.caption}}</button>
        </span>
      </div>
    </div>
  </div>
  <div class="slab-breadcrumb new-title" [class.no-pointer-events]="isUsingSebSoftware()">
    <div class="crumb-element">
      <a class="crumb" (click)="toggleMenu()" style="font-weight:600" *ngIf="isBreadcrumbMenuEnabled()">Menu</a>
      <span *ngIf="breadcrumbPath && breadcrumbPath.length" class="crumb-delim">/</span>
    </div>
    <div class="crumb-element" *ngFor="let crumb of breadcrumbPath; let isLast = last">
      <a class="crumb" [routerLink]="getCrumbRoute(crumb)">{{crumb.caption}}</a>
      <span *ngIf="!isLast" class="crumb-delim">/</span>
    </div>
  </div>
  <div *ngIf="isMenuRevealed && false" class="slab-breadcrumb buttons" style="border-top:1px solid #ccc;" [class.no-pointer-events]="isUsingSebSoftware()">
    <a class="button is-small" routerLink="/{{langService.c()}}/applicant/landing"><tra slug="lbl_applicant_landing_login_btn"></tra></a>
    <a class="button is-small" routerLink="/{{langService.c()}}/testadmin/landing"><tra slug="lbl_ta_landing_login_btn"></tra></a>
  </div>
</div>
